import { useState, useEffect } from 'react';

interface AuthBranding {
  logo_url?: string;
  login_logo_url?: string;
  favicon_url?: string;
  primary_color?: string;
  company_name?: string;
  region?: string;       
  soft_launch_mode?: boolean;
  soft_launch_trial_days?: number;
}

interface UseAuthBrandingResult {
  branding: AuthBranding | null;
  brandingLoaded: boolean;
}

export const useAuthBranding = (pageTitle?: string): UseAuthBrandingResult => {
  const [branding, setBranding] = useState<AuthBranding | null>(null);
  const [brandingLoaded, setBrandingLoaded] = useState(false);

  useEffect(() => {
    const fetchBranding = async () => {
      try {
        const response = await fetch('/api/auth/branding');
        const data = await response.json();
        setBranding(data);

        // Apply primary color
        if (data.primary_color) {
          document.documentElement.style.setProperty('--v2-primary', data.primary_color);
        }

        // Set favicon
        if (data.favicon_url) {
          const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement
            || document.createElement('link');
          link.rel = 'icon';
          link.href = data.favicon_url;
          document.head.appendChild(link);
        }

        // Set page title
        const companyName = data.company_name || 'DashboardFox';
        document.title = pageTitle ? `${pageTitle} - ${companyName}` : companyName;

      } catch (error) {
        console.error('Failed to fetch branding:', error);
      } finally {
        setBrandingLoaded(true);
      }
    };

    fetchBranding();
  }, [pageTitle]);

  return { branding, brandingLoaded };
};

export default useAuthBranding;
